// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__14Dm-","left":"StickyBox_left__1Vcdj","right":"StickyBox_right__3UTW3"};